export const sortByKey = ( array, key ) => {
	return array.sort( ( a, b ) => ( a[ key ] - b[ key ] ) );
};

export const getMapLanguage = lang => {
	const data = { region: null, language: null };

	switch ( lang ) {
		case 'sv-SE':
			data.region = 'SE';
			data.language = 'sv';
			break;
		case 'nb-NO':
			data.region = 'NO';
			data.language = 'no';
			break;
		case 'da-DK':
			data.region = 'DK';
			data.language = 'da';
			break;
		case 'fi-FI':
			data.region = 'FI';
			data.language = 'fi';
			break;
		default:
			data.region = 'GB';
			data.language = 'en';
			break;
	}

	return data;
};

/**
 * Convert html entities in strings
 *
 * @param {string} string
 */
const entities = {
	'&#038;': '&',
};

export const convertEntities = string => {
	if ( ! string ) {
		return '';
	}

	return string.replace( /&#?\w+;/, match => entities[ match ] );
};

export default null;
